'use strict';

function normalizeSlug(value) {
	return String(value || '')
		.trim()
		.toLowerCase()
		.replace(/['"]/g, '')
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '');
}

function isExhibitionViewsPost(classNames, title) {
	var classes = Array.isArray(classNames) ? classNames : [];

	if (normalizeSlug(title) === 'exhibition-views') {
		return true;
	}

	return classes.some(function(className) {
		return [
			'category-exhibition-views',
			'post-name-exhibition-views',
			'tag-exhibition-views',
			'exhibition-views',
		].indexOf(className) !== -1;
	});
}

function getWrappedSlideIndex(currentIndex, step, total) {
	if (!total) {
		return 0;
	}

	return ((currentIndex + step) % total + total) % total;
}

function getSlideDirectionFromClientX(clientX, boundsLeft, boundsWidth) {
	if (!boundsWidth) {
		return clientX < boundsLeft ? -1 : 1;
	}

	return clientX - boundsLeft < boundsWidth / 2 ? -1 : 1;
}

module.exports = {
	getSlideDirectionFromClientX: getSlideDirectionFromClientX,
	getWrappedSlideIndex: getWrappedSlideIndex,
	isExhibitionViewsPost: isExhibitionViewsPost,
	normalizeSlug: normalizeSlug,
};
